var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.errors),function(error){return _c('span',{staticClass:"text-danger d-block"},[_vm._v(_vm._s(error))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }